'use client';

import { c as _c } from "react/compiler-runtime";
import { recentLettersQuery } from '../queries.ts';
import { useSupporterQuery } from './base.ts';
export const useRecentLetters = () => {
  const $ = _c(10);
  const queryResult = useSupporterQuery(recentLettersQuery);
  let t0;
  if ($[0] !== queryResult.data) {
    t0 = queryResult.data ?? {};
    $[0] = queryResult.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    lettersAvailable: t1,
    lettersInTransit: t2
  } = t0;
  let t3;
  if ($[2] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const lettersAvailable = t3;
  let t4;
  if ($[4] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const lettersInTransit = t4;
  let t5;
  if ($[6] !== lettersAvailable || $[7] !== lettersInTransit || $[8] !== queryResult) {
    t5 = {
      ...queryResult,
      lettersAvailable,
      lettersInTransit
    };
    $[6] = lettersAvailable;
    $[7] = lettersInTransit;
    $[8] = queryResult;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};